import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import type { EmployeeProxyOrderResponse } from '@/api/@types'
import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { queryClient } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { cartKeyFactory } from './key'

type AltairOrderResponse = Awaited<
  ReturnType<typeof aspidaClient.v1.cart.order.$patch>
>

type MutationResponse = AltairOrderResponse | EmployeeProxyOrderResponse

type UseOrderCartOptions = {
  config?: Omit<
    UseMutationOptions<MutationResponse, AxiosError, undefined>,
    'mutationFn'
  >
}

export const useOrderCart = ({ config }: UseOrderCartOptions) => {
  const { storeCode } = useProxyStore()

  const mutationFn = () => {
    if (isDenebEnabled && storeCode) {
      return aspidaClient.v1.employee.proxy_stores
        ._storeCode(storeCode)
        .cart.order.$patch()
    }
    return aspidaClient.v1.cart.order.$patch()
  }

  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries(cartKeyFactory.all),
    ...config,
  } as UseMutationOptions<MutationResponse, AxiosError, undefined>)
}
